module.exports = __webpack_public_path__ + "qr-code-placeholder.svg?a9c41d5bd872b639077c7b2015baafa2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qr-code-placeholder.svg
// module id = 192
// module chunks = 0